import StoryCard from "./StoryCard";
import { stories } from "./stories.data";

export default function SuccessStoriesList() {
  return (
    <section className="relative overflow-hidden rounded-b-lg bg-[#F2F4F7] pb-4">
      {/* Decorative shape */}

      <div className="relative z-10 mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="mx-auto  text-center">

          <p className="indent-16 sm:indent-0 mt-8 md:mt-4 text-gray-600 py-4 text-left">
            Real-world examples of how we’ve helped organisations deliver
            measurable outcomes through technology.
          </p>
        </div>

        {/* Cards */}
         <div className="mt-8 space-y-8 max-w-4xl mx-auto">
          {stories.map((story) => (
            <StoryCard key={story.slug} {...story} />
          ))}
        </div>
      </div>
    </section>
  );
}
